if (!window.SprayBottleAddon) {
  window.SprayBottleAddon = (function () {
    // registry[formId] = [entry, entry, ...] — one entry per add-on block on that product form.
    // A form can now carry several add-ons (e.g. Tap Lid + For Mould + Stains on the 5L laundry page).
    var registry = {};
    var appendLock = false;

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    // Recalculate one combined total for every add-on on a form, and only show it under the last card.
    function syncGroup(formId) {
      var group = registry[formId];
      if (!group || !group.length) return;
      var total = group[0].mainCents;
      group.forEach(function (entry) {
        if (entry.checkbox.checked && !entry.checkbox.disabled) total += entry.addonCents;
      });
      group.forEach(function (entry, i) {
        if (!entry.totalEl) return;
        var wrap = entry.totalEl.closest('.spray-bottle-addon__total');
        if (wrap) wrap.style.display = i === group.length - 1 ? '' : 'none';
        entry.totalEl.textContent = formatMoney(total);
      });
    }

    function init(root) {
      var checkbox = root.querySelector('.spray-bottle-addon__checkbox');
      var card = root.querySelector('.spray-bottle-addon__card');
      var totalEl = root.querySelector('[data-spray-total]');
      if (!checkbox || !card) return;

      var formId = root.dataset.form;
      var addonVariantId = root.dataset.addonVariantId;
      var addonCents = parseInt(root.dataset.addonCents, 10) || 0;
      var mainCents = parseInt(root.dataset.mainCents, 10) || 0;

      checkbox.addEventListener('change', function () {
        card.classList.toggle('is-checked', checkbox.checked);
        if (formId) syncGroup(formId);
      });
      card.classList.toggle('is-checked', checkbox.checked);

      if (!formId || !addonVariantId) return;
      var form = document.getElementById(formId);
      if (!form) return;

      registry[formId] = registry[formId] || [];
      registry[formId].push({
        checkbox: checkbox,
        addonVariantId: addonVariantId,
        addonCents: addonCents,
        mainCents: mainCents,
        totalEl: totalEl,
        form: form
      });
      syncGroup(formId);
    }

    // Why this file no longer listens for the form's `submit` event (previous version did):
    //
    // This store runs the Monster Cart Upsell app. Its script intercepts the Add to Cart
    // button's *click* in the capture phase on `document`, calls preventDefault/stopPropagation,
    // and does its own add-to-cart request - so the browser never dispatches a native `submit`
    // event at all. A capture listener on `document` (or the form, or the button) can always be
    // pre-empted like this by another script that also uses capture and loads first, which
    // Monster's does. Confirmed live on this store: clicking Add to Cart with the add-on checked
    // fires Monster's own POST to /cart/add.js?m=true&shop=... containing only the main product's
    // variant - our old submit handler never ran.
    //
    // Fix: listen on `window` instead of `document`. `window` is always reached before `document`
    // during the capture phase, no matter which script registers first or which node Monster
    // listens on - so this always sees the click. Rather than fight Monster for control of the
    // click (fragile, and would break their own upsell drawer), we let their add-to-cart request
    // go through untouched and fire a second, independent /cart/add.js call for the add-on
    // variant(s). Shopify adds each as its own line item on the same cart either way.
    //
    // A note on timing: an earlier version of this fix delayed the add-on's own /cart/add call
    // by ~1.2s, hoping to avoid the ~1s of extra latency caused by two concurrent cart writes.
    // Testing live on this store showed that delay let it collide with one of Monster's own
    // /cart/update.js resync calls instead, and in some runs the main product's line item was
    // dropped from the cart entirely - a correctness bug, worse than the latency it was meant to
    // fix. Firing immediately, right after the click, is slower but has been reliable in repeated
    // live testing: both line items consistently land in the cart.
    //
    // Multiple add-ons: all ticked add-ons for the form go in ONE /cart/add.js request (items
    // array), so there is still only one extra cart write alongside Monster's, same as before.
    function findGroupForButton(target) {
      for (var key in registry) {
        var group = registry[key];
        if (!group.length) continue;
        var btn = group[0].form.querySelector('[type="submit"]');
        if (btn && (btn === target || btn.contains(target))) return group;
      }
      return null;
    }

    window.addEventListener(
      'click',
      function (evt) {
        var group = findGroupForButton(evt.target);
        if (!group) return;
        var ticked = group.filter(function (e) { return e.checkbox.checked && !e.checkbox.disabled; });
        if (!ticked.length || appendLock) return;

        var form = group[0].form;
        var submitButton = form.querySelector('[type="submit"]');
        if (submitButton && submitButton.getAttribute('aria-disabled') === 'true') return;

        var quantityInput = form.querySelector('[name="quantity"]');
        var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

        appendLock = true;
        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: ticked.map(function (e) {
              return { id: parseInt(e.addonVariantId, 10), quantity: quantity };
            })
          })
        })
          .then(function (response) { return response.json(); })
          .then(function (state) {
            if (state.status) {
              console.error(
                '[spray-bottle-addon] add-on failed to add to cart:',
                state.description || state.message
              );
            }
          })
          .catch(function (e) {
            console.error('[spray-bottle-addon] add-on request failed:', e);
          })
          .finally(function () {
            // Small debounce window so one click can't fire this twice (e.g. a
            // button that also responds to a stray keyboard "Enter" submit).
            setTimeout(function () { appendLock = false; }, 400);
          });
      },
      true
    );

    return { init: init };
  })();

  document.querySelectorAll('[data-spray-bottle-addon]').forEach(window.SprayBottleAddon.init);
}
